import React from 'react';
import { FaSearch } from 'react-icons/fa';
import { QuestionHeader } from '@fake-stack-overflow/shared/types/question';
import useVectorSearch from '../../hooks/useVectorSearch';
import './index.css';

const VectorSearchInput: React.FC = () => {
  const {
    results,
    isLoading,
    error,
    inputValue,
    showResults,
    isFirstSearch,
    handleInputChange,
    handleKeyDown,
    handleSearch,
    handleResultClick,
    handleBlur,
    handleFocus,
  } = useVectorSearch();

  return (
    <div className='vectorSearchInputContainer'>
      <div className='glow-effect'></div>
      <div className='inputWrapper'>
        <input
          id='vectorSearch'
          type='text'
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          onFocus={handleFocus}
          placeholder='Search with natural language...'
          className='input'
        />
        {isLoading ? (
          <div className='loadingSpinner'>
            <div className='spinner'></div>
          </div>
        ) : (
          <button onClick={handleSearch}>
            <FaSearch />
          </button>
        )}
      </div>
      {error && <p className='errorMessage'>Error: {error.message}</p>}
      {showResults && results.length > 0 && !isLoading && (
        <ul className='resultsList'>
          {results.map((result: QuestionHeader) => (
            <li
              key={String(result._id)}
              className='resultItem'
              onClick={() => handleResultClick(result)}>
              <span className='resultQuestion'>{result.title}</span>
            </li>
          ))}
        </ul>
      )}
      {!isLoading && !error && results.length === 0 && inputValue.trim() !== '' && (
        <p className='statusMessage'>
          {isFirstSearch
            ? 'Hint: hit the search icon or your enter key to search with natural language!'
            : 'No results found.'}
        </p>
      )}
    </div>
  );
};

export default VectorSearchInput;
